import type { UseContentfulImageOptions } from '@segment/utils/useContentfulImage'

export const logoImageFormats: UseContentfulImageOptions = { width: 130, height: 30, ext: `png` }

export const featuredImageFormats: UseContentfulImageOptions = {
  width: 888,
  height: 888,
  ext: `jpg`,
}
